import { IS_IOS_MOBILE, IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { getUtmString } from 'reactApp/utils/urlHelper';

export const CLOUD_SOURCE = IS_MOBILE_BROWSER ? `cloud_touch_${IS_IOS_MOBILE ? 'ios' : 'and'}` : 'cloud';

export const PaymentUTM = {
    spacePaid: getUtmString({ utm_source: CLOUD_SOURCE, utm_medium: 'web_union_quota_landing', utm_campaign: 'space_paid' }),
    spacePaidMobile: getUtmString({ utm_source: CLOUD_SOURCE, utm_medium: 'touch_subscriptions', utm_campaign: 'space_paid' }),
    spaceFree: getUtmString({ utm_source: CLOUD_SOURCE, utm_medium: 'web_union_quota_landing', utm_campaign: 'space_free' }),
    spacePaidOverquota: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'overquota_space_paid',
    }),
    spaceFreeOverquota: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'overquota_space_free',
    }),
    spaceMobile: getUtmString({ utm_source: CLOUD_SOURCE, utm_medium: 'touch_union_quota_landing', utm_campaign: 'add_space' }),
    attachesTooltip: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'attaches_tooltip_cleaner',
    }),
    spaceMenuCleaner: getUtmString({ utm_source: CLOUD_SOURCE, utm_medium: 'web_union_quota_landing', utm_campaign: 'space_menu_cleaner' }),
    spaceMenuUnionQuota: getUtmString({ utm_source: CLOUD_SOURCE, utm_medium: 'web_union_quota_landing', utm_campaign: 'space_menu_more' }),
    spaceMenuSubs: getUtmString({ utm_source: CLOUD_SOURCE, utm_medium: 'web_subscriptions', utm_campaign: 'space_menu_subs' }),
    spaceMenuBuy: getUtmString({ utm_source: CLOUD_SOURCE, utm_medium: 'web_union_quota_landing', utm_campaign: 'space_buy' }),
    spaceProgressFamily: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'family_space_progress',
    }),
    mailUploadPopup: getUtmString({ utm_source: 'mail', utm_medium: 'web_union_quota_landing', utm_campaign: '2gb_upload' }),
    mailUploadCleaner: getUtmString({ utm_source: 'mail', utm_medium: 'web_union_quota_landing', utm_campaign: '2gb_upload_cleaner' }),
    welcomeOverquota: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'welcome_overquota_cleaner',
    }),
    welcomeOverquotaGroup: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'welcome_overquota_cleaner',
    }),
    welcomeOverquotaTariffs: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'welcome_overquota',
    }),
    welcomeAttachesRepeating: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'welcome_attaches_cleaner',
    }),
    familyBuy: getUtmString({ utm_source: CLOUD_SOURCE, utm_medium: 'web_union_quota_landing', utm_campaign: 'family_space_dropdown_buy' }),
    familySubs: getUtmString({ utm_source: CLOUD_SOURCE, utm_medium: 'web_subscriptions', utm_campaign: 'family_space_dropdown_subs' }),
    familyMore: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'family_space_dropdown_more',
    }),
    familyClear: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'family_space_dropdown_clear',
    }),
    fastcheckout: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'fastcheckout_other_tariffs',
    }),
    fastcheckoutBuy: getUtmString({
        utm_source: 'mail',
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'fastcheckout_other_tariffs',
    }),
    trashbinInformer: getUtmString({ utm_source: CLOUD_SOURCE, utm_medium: 'web_union_quota_landing', utm_campaign: 'trashbin_informer' }),
    trashbinRestoreFail: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'trashbin_restore',
    }),
    fileHistory: getUtmString({ utm_source: CLOUD_SOURCE, utm_medium: 'web_union_quota_landing', utm_campaign: 'history_files' }),
    welcomePromo: getUtmString({ utm_source: CLOUD_SOURCE, utm_medium: 'web_union_quota_landing', utm_campaign: 'welcome_promo' }),
    featuresTariffsCard: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'subscriptions_tariff_no_ads',
    }),
    emptyAttaches: getUtmString({ utm_source: CLOUD_SOURCE, utm_medium: 'web_union_quota_landing', utm_campaign: 'emptystate' }),
    quotaPopup: getUtmString({ utm_source: CLOUD_SOURCE, utm_medium: 'web_union_quota_landing', utm_campaign: 'quota_popup_all_tariffs' }),
    autoDeletePromo: getUtmString({ utm_source: CLOUD_SOURCE, utm_medium: 'web_union_quota_landing', utm_campaign: 'autodelete_more' }),
    advDisableLink: getUtmString({ utm_source: CLOUD_SOURCE, utm_medium: 'web_union_quota_landing', utm_campaign: 'disable_ads_branded' }),
    advDisableLinkAnonym: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'disable_ads_branded_anonym',
    }),
    advDisableLineLinkAnonym: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'disable_ads_line_anonym',
    }),
    promoAutodeleteTooltip: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'autodelete_promo_tooltip',
    }),
    singleQuotaTooltip: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'single_quota_subs_tooltip',
    }),
    advRightBanner: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'public-ads-left',
    }),
    advRightBannerAnonym: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'public-ads-left',
    }),
    advErrorPage: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_subscriptions',
        utm_campaign: 'error_page',
    }),
    overquotaSplash: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'overquota_splash',
    }),
    overquotaSplashNew: getUtmString({
        utm_source: 'cloud_web',
        utm_medium: 'overquota_started',
        utm_campaign: 'overquota_splash_new',
    }),
    overquotaSplashNewBlocked: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'overquota_future_delete_splash',
    }),
    overquotaSplashNewCleared: getUtmString({
        utm_source: 'cloud_web',
        utm_medium: 'overquota_cleared',
        utm_campaign: 'overquota_splash_new',
    }),
    // tempexp_17125-start
    overquotaSlashEnterSpace: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'not_enough_space',
    }),
    overquotaSlashEnterCleaner: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'not_enough_space_cleaner',
    }),
    overquotaSlashViewerSpace: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'stop_files_open',
    }),
    overquotaSlashViewerCleaner: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'stop_files_open_cleaner',
    }),
    // tempexp_17125-end
    // tempexp_18060-start
    cyberMonday2025SpaceMobile: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'touch_union_quota_landing',
        utm_campaign: 'add_space_cyber_monday',
    }),
    // tempexp_18060-end
    overquotaPopupBlockFirstStepIncreaseSpace: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'overquota_future_block_popup',
    }),
    overquotaPopupBlockFirstStepClearSpace: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'overquota_future_block_popup_cleaner',
    }),
    overquotaPopupBlockSecondStepIncreaseSpace: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'overquota_future_delete_popup',
    }),
    overquotaFullBlockedNewModal: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'overquota_after_94_day',
    }),
    overquotaPopupBlockSecondStepClearSpace: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'overquota_future_delete_popup_cleaner',
    }),
    extendQuotaOfferPromo: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'completed_paid_quota',
    }),
    // tempexp_18923-start
    coverageCampaign: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'balloon_coverage_campaign',
    }),
    coverageCampaignLastCall: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'balloon_last_call_coverage_campaign',
    }),
    // tempexp_18923-end
    // tempexp_18086-start
    referralProgram: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'referal_friends_discount',
        utm_term: '18086',
    }),

    // tempexp_18086-end

    // tempexp_18926-start
    autoupload: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: IS_MOBILE_BROWSER ? 'touch_union_quota_landing' : 'web_union_quota_landing',
        utm_campaign: 'autoload_chose_tarif',
        utm_term: '18926',
    }),
    autouploadV2: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: IS_MOBILE_BROWSER ? 'touch_union_quota_landing' : 'web_union_quota_landing',
        utm_campaign: 'autoload_1tb_v2_p2',
        utm_term: '18926',
    }),
    // tempexp_18926-end

    vkMusicBundle: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'vk_music_mail_space',
    }),
    unlimitedUploadBalloon: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: IS_MOBILE_BROWSER ? 'touch_union_quota_landing' : 'web_union_quota_landing',
        utm_campaign: 'unlimited_upload_balloon',
    }),
    preOverquota: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: IS_MOBILE_BROWSER ? 'touch_union_quota_landing' : 'web_union_quota_landing',
        utm_campaign: 'avoid_overquota_banner',
    }),
    subsEndsSoonBanner: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'banner_subs_ends_soon',
    }),
    subsRecoverBanner: getUtmString({
        utm_source: CLOUD_SOURCE,
        utm_medium: 'web_union_quota_landing',
        utm_campaign: 'banner_recover_subs',
    }),
};
